import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Siren, BadgePercent, CircleDollarSign } from "lucide-react";
import { waLink } from "./shared";

const OPTIONS = [
  { icon: Siren, label: "Emergency Diagnostic", msg: "EMERGENCY: Hi AFZ Tech Solution, I need an urgent diagnostic for my device." },
  { icon: BadgePercent, label: "Book 20% Promo", msg: "Hi AFZ Tech Solution, I want to book the 20% OFF promo." },
  { icon: CircleDollarSign, label: "Ask Price Estimate", msg: "Hi AFZ Tech Solution, may I get a price estimate for a repair?" },
];

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-float">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.9 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="bg-navy/95 backdrop-blur-xl border border-brand-lime/30 rounded-2xl p-4 w-64 shadow-[0_0_35px_rgba(170,255,0,0.2)]"
          >
            <div className="flex items-center gap-2 pb-3 border-b border-white/10 mb-3">
              <span className="w-2 h-2 rounded-full bg-brand-lime animate-pulse" />
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-lime">
                Online · Replies &lt; 15 mins
              </p>
            </div>
            <div className="space-y-2">
              {OPTIONS.map((o, i) => (
                <a
                  key={o.label}
                  data-testid={`whatsapp-option-${i + 1}`}
                  href={waLink(o.msg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-slate-200 hover:bg-brand-lime/10 hover:text-brand-lime transition-colors"
                >
                  <o.icon className="w-4 h-4 text-brand-lime shrink-0" />
                  {o.label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        data-testid="whatsapp-float-button"
        onClick={() => setOpen(!open)}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="w-16 h-16 rounded-full bg-brand-lime text-void flex items-center justify-center animate-pulse-glow focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
        aria-label="Chat with AFZ on WhatsApp"
      >
        {open ? <X className="w-7 h-7" /> : <MessageCircle className="w-7 h-7" />}
      </motion.button>
    </div>
  );
};
